module.exports = __webpack_public_path__ + "static/img/Miller-Text.50e22154.svg";